import React from 'react';
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from "./Button";
var BackButton = function BackButton() {
  var handleBack = function handleBack() {
    Turbolinks.visit('/templates');
  };
  return /*#__PURE__*/React.createElement(Button, {
    outline: true,
    className: "btn mb-4",
    onClick: handleBack
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCaretLeft
  }), "\xA0  Back");
};
export default BackButton;